<aside
  class="sidebar"
  [class.sidebar--collapsed]="collapsed()"
  [class.sidebar--mobile-open]="mobileOpen()">
  <div class="sidebar__shell">
    <div class="sidebar__body">
      <div class="sidebar__logo-wrap">
        <img
          class="sidebar__logo"
          [class.sidebar__logo--collapsed]="collapsed()"
          src="assets/images/avalservi.png"
          alt="Avalservi"
          width="103"
          height="64"
          decoding="async" />
      </div>

      <nav class="sidebar__nav" aria-label="Menú principal">
        @for (item of items(); track item.route) {
          <a
            class="sidebar__link"
            [routerLink]="item.route"
            routerLinkActive="sidebar__link--active"
            [routerLinkActiveOptions]="{ exact: item.route === '/dashboard' }"
            (click)="navClick.emit()">
            <span class="sidebar__link-icon" aria-hidden="true">
              <fa-icon [icon]="['fal', item.icon]"></fa-icon>
            </span>
            @if (!collapsed()) {
              <span class="sidebar__link-label">{{ item.label }}</span>
            }
          </a>
        }
      </nav>
    </div>

    <footer class="sidebar__footer">
      <button type="button" class="sidebar__user" (click)="toggleUserMenu()">
        <span class="sidebar__avatar">{{ userInitial() }}</span>
        @if (!collapsed()) {
          <span class="sidebar__user-text">
            <span class="sidebar__user-name">{{ userName() }}</span>
            <span class="sidebar__user-role">{{ userRole() }}</span>
          </span>
          <fa-icon class="sidebar__user-chevron" [icon]="['fal', userMenuOpen() ? 'chevron-up' : 'chevron-down']"></fa-icon>
        }
      </button>

      @if (userMenuOpen() && !collapsed()) {
        <button type="button" class="sidebar__logout" (click)="onLogout()">
          <fa-icon [icon]="['fal', 'right-from-bracket']"></fa-icon>
          <span>Cerrar sesión</span>
        </button>
      }

      <button
        type="button"
        class="sidebar__collapse-btn"
        (click)="collapseToggle.emit()"
        [attr.aria-label]="collapsed() ? 'Expandir menú' : 'Colapsar menú'">
        <fa-icon [icon]="['fal', collapsed() ? 'chevrons-right' : 'chevrons-left']"></fa-icon>
      </button>
    </footer>
  </div>
</aside>
